import { Plus, X } from "lucide-react";
import { Input } from "@/components/ui/input";

interface ScopeComparisonProps {
  title?: string;
  inScopeItems: string[];
  isEditable?: boolean;
  onInScopeChange?: (items: string[]) => void;
}

export function ScopeComparison({
  title,
  inScopeItems,
  isEditable,
  onInScopeChange,
}: ScopeComparisonProps) {
  return (
    <div className="flex flex-col gap-3">
      {title && <h2 className="text-xs text-[#B0B0B0]">{title}</h2>}
      <div className="">
        <ScopeColumn
          title="In Scope"
          items={inScopeItems}
          indicatorColor="bg-[#2BAA50]"
          isEditable={isEditable}
          onChange={onInScopeChange}
        />
      </div>
    </div>
  );
}

interface ScopeColumnProps {
  title: string;
  items: string[];
  indicatorColor: string;
  isEditable?: boolean;
  onChange?: (items: string[]) => void;
}

function ScopeColumn({ title, items, indicatorColor, isEditable, onChange }: ScopeColumnProps) {
  const handleAddItem = () => {
    if (onChange) {
      onChange([...items, ""]);
    }
  };

  const handleRemoveItem = (index: number) => {
    if (onChange) {
      onChange(items.filter((_, i) => i !== index));
    }
  };

  const handleItemChange = (index: number, value: string) => {
    if (onChange) {
      const newItems = [...items];
      newItems[index] = value;
      onChange(newItems);
    }
  };

  return (
    <div
      className="flex flex-col gap-3 flex-1 p-5 rounded"
      style={{
        backgroundColor: "white",
        border: "1px solid #00000017",
      }}
    >
      <div className="flex items-center justify-start gap-2">
        <div className={`w-1 h-[18px] ${indicatorColor} rounded`} />
        <h3 className="text-base font-bold text-[#000000] leading-6 tracking-[-0.02em]">{title}</h3>
      </div>
      <div>
        {items.filter((s) => s.trim()).length > 0 ? (
          <ul className="flex flex-col gap-2">
            {items
              .filter((s) => s.trim())
              .map((content, i) => (
                <li key={i} className="gap-2 text-base text-[#000000]">
                  {isEditable ? (
                    <div className="flex items-center gap-2">
                      <div className="flex-1 w-full">
                        <Input
                          value={content}
                          onChange={(e) => handleItemChange(i, e.target.value)}
                          className="h-[44px] text-sm rounded w-full font-normal"
                          placeholder="항목을 입력하세요..."
                        />
                      </div>
                      {/* <button
                      onClick={() => handleRemoveItem(i)}
                      className="p-1 hover:bg-black/10 rounded"
                      type="button"
                    >
                      <X size={16} />
                    </button> */}
                    </div>
                  ) : (
                    <div className="rounded-[4px] w-full flex items-center">
                      <span className="w-[6px] h-[6px] rounded-full bg-[#000000]" />
                      <span className="whitespace-pre-wrap text-[14px] text-[#000000] px-2">
                        {content}
                      </span>
                    </div>
                  )}
                </li>
              ))}
          </ul>
        ) : (
          <p className="text-base text-[#BBBBBB]">-</p>
        )}
        {/* {isEditable && (
          <button
            onClick={handleAddItem}
            className="flex items-center gap-1 mt-2 text-sm text-[#007AFF] hover:underline"
            type="button"
          >
            <Plus size={14} /> 항목 추가
          </button>
        )} */}
      </div>
    </div>
  );
}
